module.exports = __webpack_public_path__ + "static/img/10.bf55932.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/addvantage/10.jpg
// module id = 6aLP
// module chunks = 1